import { Component, effect, inject, ChangeDetectionStrategy } from '@angular/core'
import { CoreService } from '../../services'
import { injectQuery } from '@tanstack/angular-query-experimental'
import { CheckoutService } from '../../services/entity-services/checkout.service'

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HomeComponent {
  private checkoutService = inject(CheckoutService)

  // Plain method, not computed(): core.services.user.roles is a mutable field on a singleton
  // service, not a signal, so computed() would track zero dependencies and freeze its value
  // after the first read — breaking permissions after a multi-account session switch (the
  // component stays mounted, so it never gets a fresh evaluation otherwise).
  public isChartsPermitted(): boolean {
    return this.core.services.user.hasOneOfTheRoles(['ROLE_DASHBOARD_CHECKOUTS', 'ROLE_SUPER_ADMIN', 'ROLE_ADMIN'])
  }
  // public analyticsUrl =
  //   'https://matomo.tomatom.cz/index.php?module=Widgetize&action=iframe&disableLink=0&widget=1&moduleToWidgetize=Live&actionToWidgetize=getSimpleLastVisitCount&idSite=1&period=day&date=yesterday&disableLink=1&widget=1&token_auth=1aa4587e94d5630bbc77443b2bf22df3'
  // public analyticsUrlSafe: SafeResourceUrl = computed(() => this.sanitizer.bypassSecurityTrustResourceUrl(this.analyticsUrl))

  readonly queryCheckouts = injectQuery(() => ({
    queryKey: ['checkouts', 'options'],
    queryFn: async () => {
      return await this.checkoutService
        .getCheckouts({ page: 1, sort: 'name', direction: 'asc' })
        .then(result => result.items)
    },
    select: data => {
      if (this.core.services.user.hasRole('ROLE_SALESMAN') && !this.core.services.user.user?.checkouts?.length) {
        // TODO CORE USER
        return []
      } else if (
        !this.checkoutService.doesUserHaveAllCheckouts(data as any[]) &&
        this.core.services.user.user?.checkouts?.length // TODO CORE USER
      ) {
        return this.core.services.user.user.checkouts.filter(ch => ch.enabled) // TODO CORE USER
      } else {
        return (data as any[]).filter(ch => ch.enabled)
      }
    },
  }))

  constructor(private core: CoreService) {
    effect(() => {
      this.queryCheckouts.data()
    })
  }
}
